import { EditableFieldProps } from '../core-field/editable-field-json-props'

/**
 * Displays the user's current GPS position and re-prompts for location
 * permissions when necessary. NM implements the capture flow today; web
 * platforms will follow.
 */
export const UI2_GEOLOCATION_FIELD_DEFAULT_PROPS: Partial<UI2GeolocationFieldProps> = {
  watchPosition: true,
  /**
   * Mobile default is 1.5 s; web default is 5 s. Set this explicitly when
   * the update cadence matters for your flow.
   */
  minSecondsBetweenUpdates: 1.5,
}

export interface UI2GeolocationFieldProps extends EditableFieldProps {
  /** Format coordinates as DMS instead of decimal. */
  showGPSAsDegree?: boolean
  /**
   * Minimum time in seconds between position updates in watch mode.
   * Ignored when `watchPosition` is false.
   */
  minSecondsBetweenUpdates?: number
  /** Continuously listen for GPS updates instead of a one-shot capture. */
  watchPosition?: boolean
  /** Show a Re-locate button so the user can manually re-capture position. Most useful when watchPosition is false. */
  allowRelocate?: boolean
  translationTable?: any
}
